export default {
  segment_labels: {
    active: 'Aktywne',
    cancelled: 'Anulowane',
    completed: 'Zakończone',
  },
};
